import React, { useState, useEffect, useRef } from "react";

import { useSelector } from "react-redux";

import { toast } from "react-toastify";

import ApiCustom from "../../utils/ApiCustom";

import PolicyModal from "../client/PolicyModal";

import DatePicker from "../DatePicker";

import * as Yup from "yup";

import { capitalizeWords } from "../../utils/helps";

import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_WIDTH = 304;

const MEMBERSHIP_FEE_POLICY_SLUG = "quy-dinh-hoi-phi";

function getRecaptchaScale(parentWidth) {
  if (!parentWidth) return 1;

  return parentWidth / RECAPTCHA_WIDTH;
}

const getValidMemberType = (memberType) => {
  return ["company", "individual"].includes(memberType) ? memberType : "company";
};

const miniSchema = Yup.object().shape({
  ceoFullName: Yup.string().trim().required("Họ tên không được để trống"),

  ceoDateOfBirth: Yup.date()
    .typeError("Sinh nhật không hợp lệ")
    .required("Sinh nhật không được để trống"),

  ceoPhone: Yup.string()
    .trim()
    .matches(
      /^(0[3|5|7|8|9])+([0-9]{8})/,
      "Số điện thoại liên hệ không đúng định dạng",
    )
    .required("Số điện thoại liên hệ không được để trống"),

  ceoEmail: Yup.string()
    .trim()
    .email("Email không đúng định dạng")
    .required("Email không được để trống"),

  ceoZalo: Yup.string()
    .trim()
    .nullable()
    .notRequired()
    .matches(/^(0[3|5|7|8|9])+([0-9]{8})/, {
      message: "Số điện thoại Zalo không đúng định dạng",

      excludeEmptyString: true,
    }),
});

const partnerMiniSchema = Yup.object().shape({
  memberType: Yup.string()
    .oneOf(["company", "individual"])
    .required("Vui lòng chọn phân loại hội viên"),

  companyName: Yup.string().when("memberType", {
    is: "company",

    then: (schema) =>
      schema.trim().required("Tên đơn vị không được để trống"),

    otherwise: (schema) => schema.trim().nullable().notRequired(),
  }),

  businessAddress: Yup.string().trim().nullable().notRequired(),

  businessField: Yup.string().trim().nullable().notRequired(),

  payMembershipFee: Yup.boolean().nullable().notRequired(),

  membershipFeeProofImage: Yup.mixed().nullable().notRequired(),
});

const MembershipFeePolicyModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isOpen) {
      getData();
    }
  }, [isOpen]);

  const getData = async () => {
    ApiCustom.get("/posts-public/")
      .then((res) => {
        const posts = res.data?.data?.data || [];

        const policyPost = posts.find(
          (item) => item?.slug === MEMBERSHIP_FEE_POLICY_SLUG,
        );

        setFormData(policyPost || {});
      })
      .catch((err) => console.log(err));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 pb-0 rounded-lg w-3/4 max-h-[90vh] overflow-y-auto">
        <div className="w-full">
          <div className="flex sticky top-0 bg-base-100 z-10 justify-end px-6 py-4 items-center ">
            <button
              type="button"
              onClick={() => onClose(false)}
              className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
            >
              X
            </button>
          </div>

          <div className="flex justify-between px-6 items-center ">
            <h1 className="text-3xl font-bold mb-4">
              {formData?.title || "Quy định hội phí"}
            </h1>
          </div>

          <div className="flow-root">
            <div className="sun-editor-editable">
              <div
                className="prose max-w-none px-6"
                dangerouslySetInnerHTML={{
                  __html:
                    formData?.content ||
                    `Bài viết quy định hội phí chưa được cấu hình. Slug cần dùng: <b>${MEMBERSHIP_FEE_POLICY_SLUG}</b>`,
                }}
              />
            </div>
          </div>

          <div className="flex sticky bottom-0 bg-base-100 z-10 p-6 pt-4 justify-end space-x-4 mt-3">
            <button
              type="button"
              onClick={() => onClose(true)}
              className="px-4 py-2 btn border-0 bg-green-600 hover:bg-green-800 rounded btn-sm text-white"
            >
              Đồng ý
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeMemberRegistrationForm = ({
  useId = false,
  defaultMemberType = "company",
}) => {
  const { loading } = useSelector((state) => state.partners);

  const [partnerFormData, setpartnerFormData] = useState({
    memberType: getValidMemberType(defaultMemberType),

    userEmail: "",

    userPhone: "",

    companyName: "",

    companyNameEn: "",

    companyShortName: "",

    businessAddress: "",

    taxCode: "",

    websiteOrHotline: "",

    hotline: "",

    businessField: "",

    position: "Tổng giám đốc/giám đốc",

    charterCapital: "",

    employeeCount: "",

    establishedDate: "",

    productService: "",

    branchOffice: "",

    payMembershipFee: false,

    membershipFeeProofImage: null,
  });

  const [ceoFormData, setCeoFormData] = useState({
    ceoFullName: "",

    ceoDateOfBirth: "",

    ceoPhone: "",

    ceoZalo: "",

    ceoEmail: "",
  });

  const [imageFormData, setimageFormData] = useState({
    logo: null,

    avatar: null,
  });

  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const [errors, setErrors] = useState({});

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [isOpenMembershipFeeModal, setIsOpenMembershipFeeModal] =
    useState(false);

  const [isMembershipFeeAccepted, setIsMembershipFeeAccepted] = useState(false);

  const [captchaToken, setCaptchaToken] = useState(null);

  const recaptchaRef = useRef(null);

  const recaptchaWrapperRef = useRef(null);

  const [recaptchaScale, setRecaptchaScale] = useState(1);

  useEffect(() => {
    const memberType = getValidMemberType(defaultMemberType);

    setpartnerFormData((prev) => ({
      ...prev,

      memberType,

      businessAddress: memberType === "individual" ? "" : prev.businessAddress,

      companyName: memberType === "individual" ? "" : prev.companyName,
    }));

    setErrors((prev) => ({
      ...prev,

      memberType: undefined,

      businessAddress: undefined,

      companyName: undefined,
    }));
  }, [defaultMemberType]);

  useEffect(() => {
    function updateScale() {
      if (recaptchaWrapperRef.current) {
        const width = recaptchaWrapperRef.current.offsetWidth;

        setRecaptchaScale(getRecaptchaScale(width));
      }
    }

    updateScale();

    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);

  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const resetCaptcha = () => {
    if (recaptchaRef.current) recaptchaRef.current.reset();

    setCaptchaToken(null);
  };

  const handleCloseModal = (value) => {
    setIsOpenModal(false);

    if (value) setAgreedToTerms(true);
  };

  const handleCloseMembershipFeeModal = (value) => {
    setIsOpenMembershipFeeModal(false);

    if (value) {
      setIsMembershipFeeAccepted(true);

      setpartnerFormData((prev) => ({
        ...prev,

        payMembershipFee: true,
      }));
    } else {
      setpartnerFormData((prev) => ({
        ...prev,

        payMembershipFee: false,

        membershipFeeProofImage: null,
      }));

      setIsMembershipFeeAccepted(false);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setCeoFormData((prev) => ({ ...prev, [name]: value }));

    try {
      await Yup.reach(miniSchema, name).validate(value);

      setErrors((p) => ({ ...p, [name]: undefined }));
    } catch (err) {
      setErrors((p) => ({ ...p, [name]: err.message }));
    }
  };

  const handlePartnerChange = async (e) => {
    const { name, value } = e.target;

    setpartnerFormData((prev) => ({
      ...prev,

      [name]: value,
    }));

    try {
      await Yup.reach(partnerMiniSchema, name).validate(value, {
        parent: {
          ...partnerFormData,

          [name]: value,
        },
      });

      setErrors((p) => ({ ...p, [name]: undefined }));
    } catch (err) {
      setErrors((p) => ({ ...p, [name]: err.message }));
    }
  };

  const handleMemberTypeChange = async (e) => {
    const value = e.target.value;

    setpartnerFormData((prev) => ({
      ...prev,

      memberType: value,

      businessAddress: value === "individual" ? "" : prev.businessAddress,

      companyName: value === "individual" ? "" : prev.companyName,
    }));

    setErrors((prev) => ({
      ...prev,

      memberType: undefined,

      businessAddress: undefined,

      companyName: undefined,
    }));
  };

  const handleTermsChange = () => {
    if (agreedToTerms) {
      setAgreedToTerms(false);

      return;
    }

    setIsOpenModal(true);

    setErrors((prev) => ({ ...prev, terms: "" }));
  };

  const handlePayMembershipFeeChange = () => {
    if (partnerFormData.payMembershipFee) {
      setpartnerFormData((prev) => ({
        ...prev,

        payMembershipFee: false,

        membershipFeeProofImage: null,
      }));

      setIsMembershipFeeAccepted(false);

      return;
    }

    setIsOpenMembershipFeeModal(true);
  };

  const handleMembershipFeeProofImageChange = (e) => {
    const file = e.target.files?.[0] || null;

    setpartnerFormData((prev) => ({
      ...prev,

      membershipFeeProofImage: file,
    }));
  };

  const renderEmailInput = () => (
    <div className="form-control">
      <div className="text-sm mb-1">
        Email <span className="text-red-500">*</span>
      </div>

      <input
        type="email"
        name="ceoEmail"
        value={ceoFormData.ceoEmail}
        onChange={handleChange}
        className={`input input-bordered w-full ${
          errors.ceoEmail ? "input-error" : ""
        }`}
      />

      {errors.ceoEmail && (
        <p className="text-red-500 text-sm">{errors.ceoEmail}</p>
      )}
    </div>
  );

  const renderBirthdayInput = () => (
    <div className="form-control">
      <div className="text-sm mb-1">
        Ngày sinh nhật <span className="text-red-500">*</span>
      </div>

      <div className="[&>div]:h-[48px] [&_input]:h-[48px] [&_input]:min-h-[48px]">
        <DatePicker
          name="ceoDateOfBirth"
          value={ceoFormData.ceoDateOfBirth}
          onChange={(name, value) => handleChange({ target: { name, value } })}
          error={errors.ceoDateOfBirth}
        />
      </div>

      {errors.ceoDateOfBirth && (
        <p className="text-red-500 text-sm">{errors.ceoDateOfBirth}</p>
      )}
    </div>
  );

  const renderBusinessFieldInput = () => (
    <div className="form-control">
      <div className="text-sm mb-1">Ngành nghề kinh doanh</div>

      <input
        type="text"
        name="businessField"
        value={partnerFormData.businessField}
        onChange={handlePartnerChange}
        className={`input input-bordered w-full ${
          errors.businessField ? "input-error" : ""
        }`}
      />

      {errors.businessField && (
        <p className="text-red-500 text-sm">{errors.businessField}</p>
      )}
    </div>
  );

  const renderPhoneInput = () => (
    <div className="form-control">
      <div className="text-sm mb-1">
        Số điện thoại <span className="text-red-500">*</span>
      </div>

      <input
        type="text"
        name="ceoPhone"
        value={ceoFormData.ceoPhone}
        onChange={handleChange}
        className={`input input-bordered w-full ${
          errors.ceoPhone ? "input-error" : ""
        }`}
      />

      {errors.ceoPhone && (
        <p className="text-red-500 text-sm">{errors.ceoPhone}</p>
      )}
    </div>
  );

  const renderZaloInput = () => (
    <div className="form-control">
      <div className="text-sm mb-1">Số điện thoại Zalo</div>

      <input
        type="text"
        name="ceoZalo"
        value={ceoFormData.ceoZalo}
        onChange={handleChange}
        className={`input input-bordered w-full ${
          errors.ceoZalo ? "input-error" : ""
        }`}
      />

      {errors.ceoZalo && (
        <p className="text-red-500 text-sm">{errors.ceoZalo}</p>
      )}
    </div>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      toast.error("Vui lòng xác nhận reCAPTCHA!");

      return;
    }

    const companyName =
      partnerFormData.memberType === "company"
        ? partnerFormData.companyName
        : ceoFormData.ceoFullName || "Hội viên";

    const nullifiedPartner = Object.fromEntries(
      Object.keys(partnerFormData).map((k) => {
        if (k === "memberType") return [k, partnerFormData.memberType];

        if (k === "position") return [k, partnerFormData.position];

        if (k === "companyName") return [k, companyName];

        if (k === "businessAddress") {
          return [
            k,

            partnerFormData.memberType === "company"
              ? partnerFormData.businessAddress
              : "",
          ];
        }

        if (k === "businessField") return [k, partnerFormData.businessField];

        if (k === "payMembershipFee")
          return [k, partnerFormData.payMembershipFee];

        if (k === "membershipFeeProofImage")
          return [k, partnerFormData.membershipFeeProofImage];

        return [k, null];
      }),
    );

    const formData = {
      ...nullifiedPartner,

      ...ceoFormData,

      ...imageFormData,
    };

    try {
      await miniSchema.validate(ceoFormData, { abortEarly: false });

      await partnerMiniSchema.validate(partnerFormData, { abortEarly: false });

      formData["ceoFullName"] = capitalizeWords(formData["ceoFullName"]);

      formData["companyName"] =
        partnerFormData.memberType === "company"
          ? formData["companyName"]
          : (formData["ceoFullName"] || "Hội viên").toUpperCase();

      const { logo, avatar, ceoZalo, membershipFeeProofImage, ...dataToRegis } =
        formData;

      dataToRegis["recaptchaCode"] = captchaToken;

      dataToRegis["referrerId"] = null;

      dataToRegis["userFullName"] = formData["ceoFullName"];

      dataToRegis["dateOfBirth"] = formData["ceoDateOfBirth"];

      dataToRegis["repEmail"] = formData["ceoEmail"];

      dataToRegis["repPhone"] = formData["ceoPhone"];

      dataToRegis["userEmail"] = formData["ceoEmail"];

      dataToRegis["ceoEmail"] = formData["ceoEmail"];

      dataToRegis["userPhone"] = formData["ceoPhone"];

      dataToRegis["ceoPhone"] = formData["ceoPhone"];

      dataToRegis["companyZaloPhone"] = ceoZalo || null;

      dataToRegis["memberType"] = partnerFormData.memberType;

      dataToRegis["companyName"] =
        partnerFormData.memberType === "company"
          ? partnerFormData.companyName
          : formData["companyName"];

      dataToRegis["businessAddress"] =
        partnerFormData.memberType === "company"
          ? partnerFormData.businessAddress
          : "";

      dataToRegis["businessField"] = partnerFormData.businessField;

      dataToRegis["payMembershipFee"] = partnerFormData.payMembershipFee;

      const submitData = new FormData();

      Object.keys(dataToRegis).forEach((key) => {
        if (dataToRegis[key] !== undefined) {
          submitData.append(key, dataToRegis[key] ?? "");
        }
      });

      if (partnerFormData.payMembershipFee && membershipFeeProofImage) {
        submitData.append("images", membershipFeeProofImage);
      }

      ApiCustom.post(`/company-register`, submitData)
        .then(async (res) => {
          if (avatar || logo) {
            const imageFD = new FormData();

            if (avatar) imageFD.append("files[]", avatar);

            if (logo) imageFD.append("files[]", logo);

            try {
              await ApiCustom.put(
                `/company-update-image/${res?.data?.data?.id}`,
                imageFD,
              );
            } catch (error) {
              console.error("Error updating images:", error);
            }
          }

          setpartnerFormData((prev) => ({
            ...prev,

            memberType: getValidMemberType(defaultMemberType),

            companyName: "",

            userEmail: "",

            userPhone: "",

            businessAddress: "",

            businessField: "",

            hotline: "",

            payMembershipFee: false,

            membershipFeeProofImage: null,
          }));

          setCeoFormData({
            ceoFullName: "",

            ceoDateOfBirth: "",

            ceoPhone: "",

            ceoZalo: "",

            ceoEmail: "",
          });

          setimageFormData({ logo: null, avatar: null });

          setErrors({});

          toast.success("Đăng ký thành công!");

          resetCaptcha();

          setAgreedToTerms(false);

          setIsMembershipFeeAccepted(false);
        })
        .catch((error) => {
          resetCaptcha();

          const status = error?.response?.status || error?.status;

          const messages = error?.response?.data?.messages;

          const responseMessage = error?.response?.data?.message;

          if (status === 422) {
            const mappedErrors = {};

            if (messages?.companyName) {
              mappedErrors.companyName = messages.companyName;
            }

            if (messages?.userPhone) {
              mappedErrors.ceoPhone = messages.userPhone;
            }

            if (messages?.userEmail) {
              mappedErrors.ceoEmail = messages.userEmail;
            }

            if (messages?.businessAddress) {
              mappedErrors.businessAddress = messages.businessAddress;
            }

            if (messages?.businessField) {
              mappedErrors.businessField = messages.businessField;
            }

            setErrors((prev) => ({
              ...prev,

              ...messages,

              ...mappedErrors,
            }));

            const firstMessage =
              messages && typeof messages === "object"
                ? Object.values(messages)[0]
                : responseMessage || "Dữ liệu không hợp lệ";

            toast.error(firstMessage);
          } else if (status === 400) {
            const errorMessage =
              typeof messages === "string"
                ? messages
                : messages && typeof messages === "object"
                ? Object.values(messages)[0]
                : responseMessage || "Đăng ký không thành công";

            toast.error(errorMessage);
          } else {
            toast.error("Đã xảy ra lỗi!");
          }
        });
    } catch (error) {
      if (error.inner) {
        const formErrors = {};

        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });

        setErrors(formErrors);
      } else {
        toast.error("Đã xảy ra lỗi!");
      }
    }
  };

  return (
    <div
      className="flex justify-center items-start w-full"
      id={useId ? "dang-ky" : ""}
    >
      <div className="w-full bg-base-100 rounded-lg py-6 px-4 md:px-8 flex flex-col gap-8 ">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-6">
            <div className="form-control">
              <div className="text-sm mb-1">
                Phân loại hội viên <span className="text-red-500">*</span>
              </div>

              <select
                name="memberType"
                value={partnerFormData.memberType}
                onChange={handleMemberTypeChange}
                className={`select select-bordered w-full ${
                  errors.memberType ? "select-error" : ""
                }`}
              >
                <option value="company">Hội viên doanh nghiệp</option>

                <option value="individual">Hội viên cá nhân</option>
              </select>

              {errors.memberType && (
                <p className="text-red-500 text-sm">{errors.memberType}</p>
              )}
            </div>

            {partnerFormData.memberType === "company" && (
              <div className="form-control">
                <div className="text-sm mb-1">
                  Tên đơn vị <span className="text-red-500">*</span>
                </div>

                <input
                  type="text"
                  name="companyName"
                  value={partnerFormData.companyName}
                  onChange={handlePartnerChange}
                  className={`input input-bordered w-full ${
                    errors.companyName ? "input-error" : ""
                  }`}
                />

                {errors.companyName && (
                  <p className="text-red-500 text-sm">{errors.companyName}</p>
                )}
              </div>
            )}

            <div className="form-control">
              <div className="text-sm mb-1">
                Họ và tên <span className="text-red-500">*</span>
              </div>

              <input
                type="text"
                name="ceoFullName"
                value={ceoFormData.ceoFullName}
                onChange={handleChange}
                className={`input input-bordered w-full capitalize ${
                  errors.ceoFullName ? "input-error" : ""
                }`}
              />

              {errors.ceoFullName && (
                <p className="text-red-500 text-sm">{errors.ceoFullName}</p>
              )}
            </div>

            {partnerFormData.memberType === "company" ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {renderEmailInput()}

                {renderBirthdayInput()}
              </div>
            ) : (
              renderEmailInput()
            )}
          </div>

          <div className="flex flex-col gap-6">
            {partnerFormData.memberType === "company" ? (
              <>
                {renderPhoneInput()}

                {renderZaloInput()}
              </>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {renderPhoneInput()}

                {renderZaloInput()}
              </div>
            )}

            {partnerFormData.memberType === "individual" &&
              renderBirthdayInput()}

            {renderBusinessFieldInput()}

            {partnerFormData.memberType === "company" && (
              <div className="form-control">
                <div className="text-sm mb-1">Địa chỉ</div>

                <input
                  type="text"
                  name="businessAddress"
                  value={partnerFormData.businessAddress}
                  onChange={handlePartnerChange}
                  className={`input input-bordered w-full ${
                    errors.businessAddress ? "input-error" : ""
                  }`}
                />

                {errors.businessAddress && (
                  <p className="text-red-500 text-sm">
                    {errors.businessAddress}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="w-full">
          <div className="flex flex-col gap-4">
            <div className="form-control">
              <label className="label cursor-pointer justify-start">
                <input
                  type="checkbox"
                  checked={partnerFormData.payMembershipFee}
                  onChange={handlePayMembershipFeeChange}
                  className="checkbox"
                />

                <span className="label-text ml-2">Đóng hội phí</span>
              </label>
            </div>

            {partnerFormData.payMembershipFee && isMembershipFeeAccepted && (
              <div className="form-control">
                <div className="text-sm mb-1">Ảnh chuyển khoản</div>

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleMembershipFeeProofImageChange}
                  className="file-input file-input-bordered w-full"
                />
              </div>
            )}

            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="form-control w-full md:w-1/2">
                <label className="label cursor-pointer justify-start">
                  <input
                    type="checkbox"
                    checked={agreedToTerms}
                    onChange={handleTermsChange}
                    className={`checkbox ${
                      errors.terms ? "checkbox-error" : ""
                    }`}
                  />

                  <span className="label-text ml-2">
                    Tôi đồng ý với điều khoản{" "}
                    <span className="text-red-500">*</span>
                  </span>
                </label>

                {errors.terms && (
                  <p className="text-red-500 text-sm">{errors.terms}</p>
                )}
              </div>

              <div
                ref={recaptchaWrapperRef}
                className="w-full flex justify-center md:w-1/2"
              >
                <div
                  className="origin-center"
                  style={{
                    transform: `scaleX(${recaptchaScale})`,

                    width: `${RECAPTCHA_WIDTH}px`,

                    height: `78px`,
                  }}
                >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={handleCaptchaChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <button
            type="submit"
            onClick={handleSubmit}
            className="btn btn-warning w-full btn-sm min-h-12 mt-4"
            disabled={loading || !agreedToTerms || !captchaToken}
          >
            {loading ? "Đang gửi..." : "Gửi thông tin"}
          </button>
        </div>

        <PolicyModal isOpen={isOpenModal} onClose={handleCloseModal} />

        <MembershipFeePolicyModal
          isOpen={isOpenMembershipFeeModal}
          onClose={handleCloseMembershipFeeModal}
        />
      </div>
    </div>
  );
};

export default HomeMemberRegistrationForm;